import { render, staticRenderFns } from "./EmployeOff.vue?vue&type=template&id=2795c278"
import script from "./EmployeOff.vue?vue&type=script&lang=js"
export * from "./EmployeOff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports